const isStateDataPoint = series => {
  const {descriptor} = series || {};
  return descriptor && Object.keys(descriptor.values || {}).length > 0;
};

const isSeriesHasLastValue = series => {
  const {last} = series || {};
  return last && last.hasOwnProperty('v');
};

export const calculateStatusDatapoints = series => {
  const stateSeries = Object.keys(series)
    .map(key => series[key])
    .filter(serie => isStateDataPoint(serie) && isSeriesHasLastValue(serie))
    .map(x => ({
      id: x.dataId,
      value: x.descriptor.values[x.last.v],
      title: x.title,
      order: x.order
    }));

  return sortAndReduce(stateSeries);
};

export const calculateNumericDatapoints = series => {
  const stateSeries = Object.keys(series)
    .map(key => series[key])
    .filter(serie => !isStateDataPoint(serie) && isSeriesHasLastValue(serie))
    .map(x => ({
      id: x.dataId,
      value: x.last.v,
      title: x.title,
      sparkline: x.meta.sparklines,
      order: x.order,
      uom: x.attrs.uom
    }));

  return sortAndReduce(stateSeries);
};

export const sortAndReduce = series => {
  return _.sortBy(series, serie => serie.order).reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});
};

export const ToLowerCase = (obj = {}) => Object.keys(obj).reduce((c, k) => ((c[k.toLowerCase()] = obj[k]), c), {});
